<template>
    <div>       
        <h1>{{title}}</h1>
        <p>{{nietbestaandevariable}}</p>
        <button @click.prevent="clickme()">test simple error</button>  
        <button @click.prevent="clickmeaxios()">async error</button>  
    </div>
</template>

<script>
'use strict'
import { util } from 'pevueglobal'
export default {        
  data() {
  return {
      title: 'todos',
      errordata: {
          'SES_taalid': 'ggg',
          'transids': [
            0
          ]
        } 
      }
  },
  methods: {
    clickme(){
      throw new Error('zomaar een error')
    },
    clickmeaxios(){
      util.getDataApi('public/PEapi_Gettranslations', this.errordata)
    }
  }
}

</script>
